import React from 'react'
import { List, ListItem, ListItemIcon, ListItemText } from '@mui/material'
import { map } from 'lodash'
import PropTypes from 'prop-types'

function DamagesList({ items }) {
  return (
    <List disablePadding>
      {map(items, ({ icon, label }, key) => (
        <ListItem key={key} disablePadding>
          <ListItemIcon>{icon}</ListItemIcon>
          <ListItemText>{label}</ListItemText>
        </ListItem>
      ))}
    </List>
  )
}

DamagesList.propTypes = {
  items: PropTypes.array,
}
DamagesList.defaultProps = {
  items: [],
}

export default DamagesList
